<template>
  <div>
    <div class="modal__trigger" @click.stop="changeState">
      <template v-if="youtubeId">
        <img
          v-if="videoThumbnail"
          :src="videoThumbnail"
          alt="Play video"
          class="modal__video-thumbnail"
        />
        <img
          v-else
          class="modal__video-thumbnail"
          :src="`https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg`"
          alt="Play Youtube video"
        />
        <div class="modal__video-playIcon"></div>
      </template>
      <slot v-else />
    </div>
    <div class="modal" :class="{ '-open': isOpen }" @click.self="changeState">
      <div class="modal__content">
        <img v-if="image" class="modal__image" :src="image" :alt="imageAlt" />
        <YoutubeEmbed v-else-if="youtubeId && isOpen" :youtube-id="youtubeId" />

        <button class="modal__close" type="button" @click="changeState">
          <Icon id="close" />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Icon from '@/components/global/Icon.vue'

import YoutubeEmbed from './YoutubeEmbed.vue'

export default {
  name: 'Modal',
  components: { Icon, YoutubeEmbed },
  props: {
    title: { type: String, default: null },
    content: { type: String, default: null },
    image: { type: String, default: null },
    imageAlt: { type: String, default: '' },
    youtubeId: { type: String, default: null },
    videoThumbnail: { type: String, default: null },
  },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    changeState() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>
